import * as React from 'react';
import { IBreadcrumb } from '../../../../types/breadcrumbs';
import * as styles from './BreadcrumbLinkButton.css';
import { UIText2 } from '@cian/ui-kit';

export const BreadcrumbLinkButton: React.FC<IBreadcrumb> = ({ title, url }) => {
  return (
    <a href={url} className={styles['link-button']}>
      <UIText2 color="gray60_100">{title}</UIText2>
    </a>
  );
};
